// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Tutorial_ProgressResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

import type { Tutorial_ProgressRow } from './Tutorial_ProgressRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Tutorial_ProgressResponseDados = Tutorial_ProgressRow[];

export type Tutorial_ProgressResponse = ApiResponse<Tutorial_ProgressResponseDados>;

registerResponseContract('Tutorial_ProgressResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      tutorial_slug: { type: 'string',  required: true },
      status:        { type: 'string',  required: true },
      step_reached:  { type: 'string',  required: true },
      replay_count:  { type: 'string',  required: true },
      started_at:    { type: 'string',  required: true },
      completed_at:  { type: 'string',  required: false },
    },
  },
})
